import { reverseGeocodeRequest } from "@common/helpers/googleMaps/geocoderService";
import { ReverseGeocodeAddress } from "./types/ReverseGeocodeAddress";

const reverseGeocode = async (
  latitude: number,
  longitude: number
): Promise<ReverseGeocodeAddress | null> => {
  try {
    const results = await reverseGeocodeRequest({
      lat: latitude,
      lng: longitude,
    });

    if (results == null || results.length === 0) return null;

    const formattedAddress = results[0].formatted_address;
    const addressComponents = results[0].address_components;

    let city = "";
    let state = "";
    let stateAbbr = "";
    let country = "";

    for (let i = 0; i < addressComponents.length; i += 1) {
      const component = results[0].address_components[i];

      if (component.types.includes("locality")) {
        city = component.long_name;
      } else if (component.types.includes("administrative_area_level_1")) {
        stateAbbr = component.short_name;
        state = component.long_name;
      } else if (component.types.includes("country")) {
        country = component.long_name;
      }
    }

    return {
      city,
      province: state,
      provinceAbbr: stateAbbr,
      country,
      formattedAddress,
    };
  } catch {
    return null;
  }
};

export default reverseGeocode;
